<template lang="pug">
  .container
    h1.main_title Users Activity
    .col-md-12(v-if="dataLoading")
      .loader
    .col-md-12(v-else)
      pagination(
        v-if="outputData.length > 10"
        v-bind:target-ary.sync='outputData'
        v-bind:count-of-page.sync="countOfPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-page.sync="currentPage"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        count-of-page-range="large"
      )
      table.table.table-bordered.table-striped
        thead
          th ID
          th Date
            .pull-right
              span.glyphicon.clickable(
                :class="currentSortOptions['time'] !== null ? currentSortOptions['time'] ? 'glyphicon-sort-by-attributes' : 'glyphicon-sort-by-attributes-alt' : 'glyphicon-sort sort_default'"
                @click="sortBy('time')"
              )
          th Event
            .pull-right
              span.glyphicon.clickable(
                :class="currentSortOptions['type'] !== null ? currentSortOptions['type'] ? 'glyphicon-sort-by-order' : 'glyphicon-sort-by-order-alt' : 'glyphicon-sort sort_default'"
                @click="sortBy('type')"
              )
          th User
            .pull-right
              span.glyphicon.clickable(
                :class="currentSortOptions['name'] !== null ? currentSortOptions['name'] ? 'glyphicon-sort-by-alphabet' : 'glyphicon-sort-by-alphabet-alt' : 'glyphicon-sort sort_default'"
                @click="sortBy('name')"
              )
          th IP
            .pull-right
              span.glyphicon.clickable(
                :class="currentSortOptions['ip'] !== null ? currentSortOptions['ip'] ? 'glyphicon-sort-by-alphabet' : 'glyphicon-sort-by-alphabet-alt' : 'glyphicon-sort sort_default'"
                @click="sortBy('ip')"
              )
        tbody
          tr(v-for="accessLog in outputData | limitBy countOfPage pageStart")
            td {{ $index + pageStart + 1 }}
            td {{ accessLog.time | timeFormat 'YYYY/MM/DD hh:mm:ss A' }}
            td
              span.badge.online(v-if="accessLog.type")  Online 
              span.badge.offline(v-else)  Offline 
            td
              img.img-rounded(
                style="width: 20px; height: 20px;"
                v-bind:src="accessLog.photoLink"
              )
              span  {{ accessLog.name }}
            td {{ accessLog.ip }}
</template>

<script>
  import { getUserRef } from 'src/index'
  import pagination from 'src/components/common/Pagination.vue'
  // import axios from 'axios'
  import _ from 'lodash'

  export default {
    components: {
      pagination
    },
    data () {
      return {
        /* default */
        outputData: [],
        /* data status */
        fbUserLoaded: false,
        /* pagination */
        countOfPage: 25,
        countOfPagination: 5,
        currentPage: 1,
        currPaginationSec: 1,
        /* sort data */
        currentSortOptions: {
          'time': false,
          'type': null,
          'name': null,
          'ip': null
        }
      }
    },
    firebase () {
      return {
        fbUser: {
          source: getUserRef(),
          asObject: true,
          readyCallback: () => {
            this.fbUserLoaded = true
          }
        }
      }
    },
    computed: {
      pageStart () {
        return (this.currentPage - 1) * this.countOfPage
      },
      dataLoading () {
        if (this.fbUserLoaded) {
          const fbu = {...this.fbUser}

          const handledData = []
          _.forEach(fbu, (user, index) => {
            const accessLog = user.accessLog
            if (accessLog) {
              const { name, email, photo_link: photoLink = '/static/svg/UnknownUser.svg' } = user
              _.forEach(accessLog, (log, key) => {
                handledData.push({
                  name,
                  email,
                  photoLink,
                  ...log
                })
              })
            }
          })
          // console.log(handledData)

          /* sort data */
          const sortType = []
          const AorDESC = []
          _.forEach(this.currentSortOptions, (value, key) => {
            if (value !== null) {
              sortType.push(key)
              AorDESC.push(value ? 'asc' : 'desc')
            }
          })
          // console.log(sortType, AorDESC)

          this.outputData = _.orderBy(handledData, sortType, AorDESC)

          return false
        } else {
          return true
        }
      }
    },
    ready () {

    },
    methods: {
      sortBy (type) {
        const option = this.currentSortOptions
        switch (option[type]) {
          case null:
            option[type] = false
            break
          case false:
            option[type] = true
            break
          case true:
            option[type] = null
            break
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.sort_default {
  color: rgba(199, 199, 199, 0.5);
}

.badge {
  &.offline {
    color: #FFF;
    background-color: #777;
  }
  &.online {
    color: #FFF;
    background-color: #00cc53;
  }
}

</style>



// WEBPACK FOOTER //
// Activity.vue?5c8f872e